// Convert spherical coordinates to Cartesian coordinates
// Inputs: alpha and beta are in degrees
export const sphericalToCartesian = (radius: number, alpha: number, beta: number) => {
  // Convert degrees to radians for calculations
  const alphaRad = ((90 - alpha) * Math.PI) / 180; // Adjust alpha to match the spherical convention
  const betaRad = ((beta - 90) * Math.PI) / 180; // Adjust beta to match the spherical convention

  // Perform calculations
  const x = Math.round(radius * Math.sin(betaRad) * Math.cos(alphaRad));
  const y = Math.round(radius * Math.cos(betaRad));
  const z = Math.round(radius * Math.sin(betaRad) * Math.sin(alphaRad));

  // Return the Cartesian coordinates
  return { x, y, z };
};

// Convert Cartesian coordinates to spherical coordinates
// Outputs: alpha and beta are in degrees
export const cartesianToSpherical = (x: number, y: number, z: number) => {
  const radius = Math.round(Math.sqrt(x * x + y * y + z * z));
  const betaRad = Math.atan2(z, x); // Azimuthal angle in radians
  let alphaRad = Math.acos(y / radius); // Polar angle in radians

  if (isNaN(alphaRad)) {
    alphaRad = 0;
  }

  // Convert radians to degrees
  const alpha = 90 - Math.round(alphaRad * (180 / Math.PI));
  const beta = 90 + Math.round(betaRad * (180 / Math.PI));

  return { radius, alpha, beta };
};
